import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { BaseLoginResponse } from "../../../../base/response/BaseLoginResponse";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { LoginService } from "../../../../generated/grpc/login_pb";
import { grpcFincaLoteDatabase } from "../../../terceros/database/GrpcFincaLoteDatabase";
import { LoginByEmailPasswordRequest } from "../request/LoginByEmailPasswordRequest";
import { mapGrpcLoginResponse } from "./mapGrpcLoginResponse";
import { secureStorage } from "./SecureStorageService";

/** Login por email/password (`LoginService.LoginAuthWeb`, gRPC-Web): persiste
 *  el token de sesión cifrado en `secureStorage` al éxito y descarta el que el
 *  transporte tenía en memoria, para que las llamadas siguientes usen el nuevo
 *  sin recargar la página. Implementa
 *  `ISaveService` directo, el único contrato que de verdad necesitan
 *  `Login.ts`/`BaseInit.ts`. */
export class LoginByEmailPasswordGrpcService<TResponse extends BaseLoginResponse>
  implements ISaveService<LoginByEmailPasswordRequest, TResponse>
{
  async saveAsync(request: LoginByEmailPasswordRequest): Promise<TResponse> {
    const client = createClient(LoginService, grpcTransportProvider.get());

    let grpcResponse;
    try {
      grpcResponse = await client.loginAuthWeb({
        email: request.email,
        password: request.password,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    // Best-effort: si falla, no debe tirar abajo un login que por lo demás
    // salió bien.
    grpcFincaLoteDatabase
      .replaceAllAsync(grpcResponse.fincas)
      .catch((error: unknown) =>
        console.error("No se pudo guardar fincas/lotes de gRPC login:", error),
      );

    const response = mapGrpcLoginResponse<TResponse>(grpcResponse);
    await secureStorage.set(response.token);
    // El transporte pudo haber guardado en memoria una sesión anterior.
    grpcTransportProvider.clearToken();
    return response;
  }
}
